module.exports = __webpack_public_path__ + "img/icon-wpg.00e0dd5b.svg";